/**
 * IdentityVerificationInfoRemapper
 *
 * Parses Firestore wire JSON into an `IdentityVerificationInfoDto`.
 * Flutter source: lib/data/models/identity_verification_info.dart (no @JsonKey — Dart property == Firestore field).
 */
import type { IdentityVerificationInfoDto } from '@/data/dtos/info/identityVerificationInfoDto';
import type { JsonObject } from '@/data/types/json';

export class IdentityVerificationInfoRemapper {
  static fromJson(data: JsonObject): IdentityVerificationInfoDto {
    return {
      status: (data['status'] as number | undefined) ?? 0,
      declineReason: data['declineReason'] as number | undefined,
    };
  }

  static fromJsonList(dataList: JsonObject[]): IdentityVerificationInfoDto[] {
    return dataList.map(IdentityVerificationInfoRemapper.fromJson);
  }
}
